import React from 'react';

import * as ROUTES from '../Constants/routes';

import { Nav, Navbar, NavDropdown } from 'react-bootstrap';
 
const Navigation = () => {
    return (
      <Navbar collapseOnSelect expand="lg" bg="dark" variant="dark">
        <Navbar.Brand href={ROUTES.CUSTOM_HOME}>
          Arnav Adhikari
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="mr-auto">
            <Nav.Link href={ROUTES.HOME}>Home</Nav.Link>
            <Nav.Link
              href={ROUTES.PUBLICATIONS}
              style={{ marginRight: "-12px" }}
            >
              Publications
            </Nav.Link>
            <NavDropdown title="" id="collasible-nav-dropdown">
              <NavDropdown.Item href={ROUTES.PUBLICATIONS_MATH}>
                Math
              </NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item href={ROUTES.PUBLICATIONS_CODE}>
                Code
              </NavDropdown.Item>
            </NavDropdown>
            <Nav.Link href={ROUTES.CONTACT}>Contact</Nav.Link>
          </Nav>
          <Nav>
            <span style={{ color: "white" }}>
              <em>"The secret of getting ahead is getting started."</em> - Mark
              Twain
            </span>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    );
}
 
export default Navigation;